import script from "./code.vue?vue&type=script&setup=true&lang=js"
export * from "./code.vue?vue&type=script&setup=true&lang=js"

import "./code.vue?vue&type=style&index=0&id=4d80d186&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d80d186"]])

export default __exports__